import React, { useContext }  from 'react'
import AdhesivesProduct from './AdhesivesProduct'
import { AppContext } from '../../../App'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'

export default function AdhesivesProductList() {
    const { adhesivesProducts } = useContext(AppContext)
   // Collate all adhesives subcategories into array
   const allAdhesivesSubCategories = adhesivesProducts.map(g => g.subCategory)
   // Remove duplicate adhesives subcategories in array
   const adhesivesSubCategories = [...new Set(allAdhesivesSubCategories)]
    const iconAngleDown = <FontAwesomeIcon icon={faAngleDown} color="#ffffff" />
   return (
      <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
      {
               adhesivesSubCategories.map((asc, index) => {
            return asc!=='' && ( // REMOVE THIS CONDITIONAL ONCE ALL ADHESIVE ITEMS HAVE SUBCATEGORIES APPLIED
               <div className="panel panel-primary" key={ asc }>
                  <div className="panel-heading" role="tab" id={ "heading-" + asc }>
                        <a role="button" data-bs-toggle="collapse" data-parent="#accordion" href={ "#collapse-" + index } aria-expanded="true" aria-controls={ "collapse-" + index }>
                           <h4 className="panel-title">{ iconAngleDown } { asc }</h4>
                        </a>
                  </div>
                  <div id={ "collapse-" + index } className={ index===0 ? "panel-collapse collapse show" : "panel-collapse collapse" } role="tabpanel" aria-labelledby={ "heading-" + asc }>
                        <div className="panel-body">
                           {
                                adhesivesProducts.map((a, index) => {
                                    return a.subCategory===asc && (
                                       <AdhesivesProduct key={ a.adhesivename } productIndex={ index } { ...a } />
                                    )
                              })
                           }
                        </div>
                  </div>
               </div>
            )
         })
      }
      {
         // If the products array contains any subCategory value of null.
         adhesivesProducts.some(a => !a.subCategory) && (
            <div className="panel panel-default" key={ "no-subcategory" }>
               <div className="panel-heading" role="tab" id={ "heading-no-subcategory" }>
                  <a role="button" data-bs-toggle="collapse" data-parent="#accordion" href={ "#collapse-no-subcategory" } aria-expanded="true" aria-controls={ "collapse-no-subcategory" }>
                        <h4 className="panel-title">
                           { iconAngleDown } Uncategorized Adhesives
                        </h4>
                  </a>
               </div>
               <div id={ "collapse-no-subcategory" } className="panel-collapse collapse" role="tabpanel" aria-labelledby={ "heading-no-subcategory" }>
                  <div className="panel-body">
                  {
                        adhesivesProducts.map((a, index) => {
                           return !a.subCategory && (
                              <AdhesivesProduct key={ a.name } productIndex={ index } { ...a } />
                           )
                        })
                  }
                  </div>
               </div>
            </div>
         )
      }
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/adhesives/AdhesivesProductList.js